import React, { useRef, useEffect, useState } from "react";
import { Headings } from "@mindarc/arctheme-components/frontend/src/stories/components/elements/Headings/Headings";
import ExtendedImage from "../../ExtendedImage/ExtendedImage";
import { constructFullAddress, formatPrice, uniqueAddressIdGenerator } from 'frontend/js/helpers';
import { fetchCart, updateItem } from 'frontend/js/useShopifyCart';
import shippingitem from "../../../../../js/alpine/components/cart/shippingitem";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import {mobileBreakpoint} from "../../../../../entrypoints/theme";
import ExtendedButton from '@src/stories/elements/ExtendedButton/ExtendedButton';
import { ProductType } from './CartEnums';

const ImagePlaceholderSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5">
      <path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z"/>
      <path d="M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z"/><path d="M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z"/>
  </svg>
)

export default function ReviewContent ({ selectedShippingType, cart, address, translations, card_types, deliveryMap, chilledDeliveryMap, shipping_id, bundleType }) {
  const [groupedItems, setGroupedItems] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [updatingCart, setUpdatingCart] = useState(true);
  const fullAddress = constructFullAddress(address);
  const [ stepStatus , setStepStatus] = useState('INIT');
  const [ deliveryInstructions, setDeliveryInstructions] = useState({});
  const hasLoadedCart = useRef(false); 
  const submitCheckoutBtn = useRef(null); 
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  const hasChilledDelivery = cart.items.some((item) => item.properties._Chilled_Delivery === "true" || item.properties._Chilled_Delivery == true);

  const onTitleClick = (index) => {
      setActiveIndex(index === activeIndex ? null : index);
  };

  useEffect(() => {
    window.scrollTo(0, 0); 
    const loadCart = async () => {
      if(stepStatus == 'INIT' && !hasLoadedCart.current) {
        setUpdatingCart(true);
        hasLoadedCart.current = true; 
        await fetchCart(); 
        setStepStatus('FETCH');
      }
      
    };
    if(stepStatus == 'INIT') {
      loadCart();
    }
  }, []);
  
  const groupItemsByDeliveryDateAndShippingRate = (data) => {
    const groupedItems = {};
    const consignmentCounts = {};
    const giftCardGroup = {
      consignmentKey: 'Gift Cards',
      _delivery_date: null,
      _shipping_rate: null,
      shipping_price: null,
      items: []
    };
  
    data.forEach((item) => {
      const { _delivery_date, _shipping_rate, _consignment, _shipping_zip, _shipping_address, _shipping_address1, _shipping_city, _shipping_province, _shipping_country } = item.properties;
       const uniqueId = uniqueAddressIdGenerator(_shipping_address1, _shipping_city, _shipping_province, _shipping_zip, _shipping_country);
      const { product_type } = item;
  
      if (product_type === "Gift Cards") {
        giftCardGroup.items.push(item);
        return;
      }
  
      if (product_type == bundleType || !_consignment) return false;
      const groupKey = `${_delivery_date}-${_shipping_rate}-${_shipping_address}`;
      const itemIsChilled = item.properties._Chilled_Delivery == "true"  || item.properties._Chilled_Delivery == true;
      const validDeliveryMap = selectedShippingType == 'SINGLE' ? hasChilledDelivery ? chilledDeliveryMap : deliveryMap : itemIsChilled ? chilledDeliveryMap : deliveryMap;
      
      if (!groupedItems[groupKey]) {
          groupedItems[groupKey] = {
              _delivery_date,
              _shipping_rate,
              consignmentKey: '',
              shipping_price: selectedShippingType == 'SINGLE' ? validDeliveryMap[_shipping_rate] && validDeliveryMap[_shipping_rate].raw_price : validDeliveryMap[uniqueId][_shipping_rate] && validDeliveryMap[uniqueId][_shipping_rate].raw_price,
              items: []
          };
      }
  
      if (!consignmentCounts[_consignment]){ 
          consignmentCounts[_consignment] = [groupKey]; 
      } else if (!consignmentCounts[_consignment].includes(groupKey)) {
          consignmentCounts[_consignment].push(groupKey); 
      }
  
      const consignmentKey = `${_consignment} Consignment - ${_shipping_address1}`;
      groupedItems[groupKey].consignmentKey = consignmentKey;
      groupedItems[groupKey].items.push(item);
    });
  
    const result = Object.values(groupedItems);
    if (giftCardGroup.items.length > 0) {
      result.push(giftCardGroup);
    }
    return result;
  };
  
  function mergeItems(groupedItems) {
    const bundledAndMergedItems: unknown[][] = [];
    groupedItems.forEach(groupedItem => {

      if (groupedItem.consignmentKey === 'Gift Cards') {
        bundledAndMergedItems.push({
          ...groupedItem,
          items: groupedItem.items
        });
        return;
      }

      const mergedItems = {};
      groupedItem.items.forEach(item => {
        if (item.product_type === ProductType.GREETING_CARDS || item.product_type === ProductType.GIFT_WRAPPING) {
          const uniqueKey = `${item.product_title}-${item.key}`;
          mergedItems[uniqueKey] = { ...item };
          return;
        }

        let key = `${item.product_title}-${item.properties._shipping_address}-${item.properties._shipping_first_name}-${item.properties._shipping_last_name}`;

        if (item.properties._recipient_name) {
          key += `-${item.properties._recipient_name}`;
        }
        if (item.properties['Uploaded Image']) {
          key += `-${item.properties['Uploaded Image']}`;
        }
        if (item.properties['Messaging']) {
          key += `-${item.properties['Messaging']}`;
        }

        const monogramKeys = Object.keys(item.properties).filter(k => k.startsWith('monogram'));
        if (monogramKeys.length > 0) {
          key += '-' + monogramKeys
            .map(k => `${k}:${item.properties[k]}`)
            .join('|');
        }

        if (mergedItems[key]) {
          mergedItems[key].quantity += item.quantity;
        } else {
          mergedItems[key] = { ...item };
        }
      });

      bundledAndMergedItems.push({
        ...groupedItem,
        items: Object.values(mergedItems)
      });
    });
    return bundledAndMergedItems;
  }

  const mergedResult = mergeItems(groupedItems)
  
  async function updateLineItems (items) {
    for (const cartItem of items) {
      for (const item of cartItem.items) {
        if(item.product_type == bundleType) {
          continue;
        }
  
  
        const prefixesToRemove = ['_itemIndex'];
        const keysToRemove = ['_delivery_date_end', '_Chilled_Delivery', '_delivery_date_start'];
  
        const filteredProperties = Object.keys(item.properties)
          .filter(key => !prefixesToRemove.some(prefix => key.startsWith(prefix) &&
          !keysToRemove.includes(key)))
          .reduce((obj, key) => {
            obj[key] = item.properties[key];
            return obj;
          }, {});
  
  
        await updateItem({
          id: item.key,
          quantity: item.product_type === ProductType.GREETING_CARDS || item.product_type === ProductType.GIFT_WRAPPING ? item.quantity : 1,
          properties: {
            ...filteredProperties,
            "_shipping_delivery_instructions": deliveryInstructions && deliveryInstructions[cartItem.consignmentKey],
            "_bundle": cartItem.consignmentKey,
            "_groupId": cartItem.consignmentKey
          }
        }, true);
        
      }
    }
  }

  const monogramDisplay = (item) => {
    return (
    Object.keys(item.properties || {}).some(key => key.startsWith('monogram')) && (
      <p className='text-sm'>
          <span className="font-medium mr-2">Monogram:</span> {item.properties['monogram-font']}, 
          {item.properties['monogram-text-1'] && 
            <span> {item.properties['monogram-text-1'].length > 10
              ? `${item.properties['monogram-text-1'].substring(0, 10)}...` 
              : item.properties['monogram-text-1']}</span>
          }
          {item.properties['monogram-text-2'] && 
            <span>, {item.properties['monogram-text-2'].length > 10
              ? `${item.properties['monogram-text-2'].substring(0, 10)}...` 
              : item.properties['monogram-text-2']}</span>
          }
      </p>
    )
    )
  }

  
  const customPropertyDisplay = (item) => {
    return (Object.entries(item.properties || {})
    .filter(([key, value]) => key.startsWith('custom_') && value)
    .map(([key, value]) => {
      const label = key
        .replace(/^custom_/, '')
        .replace(/_/g, ' ')
        .replace(/\b\w/g, l => l.toUpperCase());
      return (
        <p className='text-sm' key={key}>
            <span className="font-medium mr-2">{label}:</span> {value}
        </p>
      );
    })
  )
  }


  const addOnTypeDisplay = (item) => {
    if (item.product_type !== ProductType.GREETING_CARDS && item.product_type !== ProductType.GIFT_WRAPPING) return null;
    return (
        <div className='text-sm' key={item.key}>
          <strong>Type:</strong> {item?.variant_title}
        </div>
      );
  }

  const messagingDisplay = (item) => {
    return (
     item.properties['Messaging']  && 
        <div className='text-sm my-[10px]'>
            <span className="font-medium mr-2"> Messaging: </span>
            <span className="font-[400]" > {item.properties['Messaging']}</span>
        </div>
    );
  }

  const uploadedImageDisplay = (item) => {
    const url = item.properties['Uploaded Image'];
    return (
       item.properties['Uploaded Image']  &&  <div className='text-sm my-[10px]'>
        <span className="font-medium mr-2"> Uploaded Image: </span>
        <a  className="font-[400]" target="_blank" href={url}>{url}</a>
      </div>
    );
  }

  useEffect(() => {
    const updateShippingProductAndCart = async () => {
        await shippingitem.component().checkAndUpdateShippingProduct(groupItemsByDeliveryDateAndShippingRate(cart.items), shipping_id);
        setUpdatingCart(false);
        setStepStatus('FINALIZE');
    };
  
    if(stepStatus == 'FETCH') {
      setGroupedItems(groupItemsByDeliveryDateAndShippingRate(cart.items));
      updateShippingProductAndCart();
    }
  
  }, [stepStatus])
  

  
  async function handleValidation () {
    setUpdatingCart(true)
    await updateLineItems(groupItemsByDeliveryDateAndShippingRate(cart.items))
    submitCheckoutBtn.current.submit();
  }
  
  const validDeliveryMap = hasChilledDelivery  ? chilledDeliveryMap : deliveryMap;


    return (
        <div className="accordion mx-6 lg:mx-[64px]">
          <div className="max-h-[70vh] overflow-scroll no-scroll-bar mb-4">  
            {mergedResult.map((cartItem, index) => {
              const consignmentLabel = cartItem?.consignmentKey.split('-')[0];
                return (
                  <div key={index}>
                      <div className="accordion__header" onClick={() => onTitleClick(index)}>
                        <div className={'accordion__title text-[16px] !p-0 lg:text-[20px] font-[500]'}>{consignmentLabel}</div> 
                          <span className={`accordion__toggle text-[24px] cursor-pointer ${activeIndex === index ? 'icon-chevron-up' : 'icon-chevron-down'}`}> </span> 
                      </div>
                      <div className="extended-cart__consignment accordion-content mt-6 !px-0 !overflow-auto no-scroll-bar"  style={{ maxHeight: activeIndex === index ? '50vh' : '0',  }}>
                        {cartItem.items.map((item, itemIndex) => {
                          return (
                        
                              <div key={item.key} className={`flex gap-4 pb-6`}>
                              { isMobile && ( 
                                  <div className='extended-cart__item'>
                                      <div className="flex flex-row gap-4 mb-2">
                                        {!item.image ? <ImagePlaceholderSVG/> : 
                                          <ExtendedImage
                                            imageUrl={item.image}
                                            altText={item.product_title}
                                            className={'object-cover w-full h-full'}
                                          />
                                        }
                                        <div>
                                          <div className='font-medium text-[14px] lg:text-[16px] pb-1'>
                                            {item.product_title}
                                          </div>
                                        </div>
        
                                      </div>
                                  
                                      <div> 
                                        <div className="flex flex-row justify-between"> 
                                          <p>
                                              <span className='font-medium mr-2'>
                                                {translations.price}:
                                              </span>
                  
                                              {formatPrice(item.price)}
                                          </p>
                                            
                                          <p>
                                            <span className='font-medium mr-2'>
                                              {translations.qty}:
                                            </span>
                
                                            {item.quantity}
                                          </p>
                                        </div>
                                      
                                      {selectedShippingType == 'SINGLE' && item.product_type !== 'Gift Cards' &&
                                        <>
                                         { item.properties._recipient_name && <p>
                                            <span className='font-medium mr-2'>
                                              {translations.recipient_name}:
                                            </span>
                                      
                                            {item.properties._recipient_name} 
                                          </p>
                                          }

                                     
        
                                          <p>
                                            <span className='font-medium mr-2'>
                                              {translations.address}:
                                            </span>
                                            
                                            {fullAddress}
                                          </p>
                                        </>
                                      }

                                      {monogramDisplay(item)}
                                      {messagingDisplay(item)}
                                      {customPropertyDisplay(item)}
                                      {addOnTypeDisplay(item)}
                                      {uploadedImageDisplay(item)}
                                      </div>
        
                                  </div>
                                )}
                                { !isMobile && (
                                  <div className='extended-cart__item'>
                                    {!item.image ? <ImagePlaceholderSVG/> : 
                                      <ExtendedImage
                                        imageUrl={item.image}
                                        altText={item.product_title}
                                        className={'object-cover w-full h-full'}
                                      />
                                    }
                                  <div>
                                      <div className='font-medium text-[14px] lg:text-[16px] pb-1'>
                                        {item.product_title}
                                      </div>
            
                                      <p>
                                        <span className='font-medium mr-2'>
                                          {translations.price}:
                                        </span>
            
                                        {formatPrice(item.price)}
                                      </p>
                                      
                                      <p>
                                        <span className='font-medium mr-2'>
                                          {translations.qty}:
                                        </span>
            
                                        {item.quantity}
                                      </p>
                                      
                                
                                      {selectedShippingType == 'SINGLE' && item.product_type !== 'Gift Cards' &&
                                        <>
                                          { item.properties._recipient_name && <p >
                                            <span className='font-medium mr-2'>
                                              {translations.recipient_name}:
                                            </span>
                                      
                                            {item.properties._recipient_name} 
                                          </p>
                                          }

                                          <p>
                                            <span className='font-medium mr-2'>
                                              {translations.address}:
                                            </span>
                                            
                                            {fullAddress}
                                          </p>
                                        </>
                                      }

                                    { item.properties[`Recipient name`] && (
                                        <p>
                                          <span className='font-medium mr-2'>
                                            {translations.recipient_name}:
                                          </span>
                                          { item.properties[`Recipient name`]}
                                        </p>
                                      )}
                                      { item.properties[`Recipient email`] && (
                                        <p>
                                          <span className='font-medium mr-2'>
                                            {translations.recipient_email || 'Recipient email'}:
                                          </span>
                                          { item.properties[`Recipient email`]}
                                        </p>
                                      )}

                                    {monogramDisplay(item)}
                                    {messagingDisplay(item)}
                                    {customPropertyDisplay(item)}
                                    {addOnTypeDisplay(item)}
                                    {uploadedImageDisplay(item)}
                                  </div>
                                  </div>
                                )}
                              </div>
                          
                          )
                        })}
                      </div>
                  </div>
                )
            })}
          </div>
          <div className={'w-100 mx-auto mb-8 justify-center flex'}>
              <ExtendedButton
                    label={'Checkout'}
                    style='primary'
                    className={`!w-[200px]`}
                    disabled={updatingCart}
                    onClick={() => handleValidation()}
              />
          </div>
          <form id="checkout" action="/checkout" method="post" ref={submitCheckoutBtn}></form>
     
        </div>
 
    )
  }



export const ExtendedCartReviewModal = ({
  modal_id,
  isOpen,
  onClose,
  selectedShippingType, cart, cartItems, address, translations, card_types, deliveryMap, chilledDeliveryMap, shipping_id, bundleType 
}) => {
  if (!isOpen) return null;
  const isMobile = useMobileBreakpoint(mobileBreakpoint);
  return (
    <div
      id={`${modal_id}`}
      className={`fixed inset-0 flex items-center justify-center bg-gray-600 bg-opacity-40 overflow-y-auto w-full  h-full z-50`}
      style={{ backdropFilter: "blur(6px)" }}
    >
      <div className={`border shadow-lg rounded-md overflow-scroll lg:overflow-auto bg-[#FFFEF5] w-[95vw] lg:w-[55vw] h-auto flex flex-col`}>
          <div className="flex py-0 flex-col">
              <button
                  className="p-4 h-6 text-[24px] border-none w-full flex justify-end"
                  onClick={onClose}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M16.192 6.34375L11.949 10.5858L7.70697 6.34375L6.29297 7.75775L10.535 11.9998L6.29297 16.2418L7.70697 17.6558L11.949 13.4137L16.192 17.6558L17.606 16.2418L13.364 11.9998L17.606 7.75775L16.192 6.34375Z"
                      fill="black"
                    />
                  </svg>
              </button>
              <div className="w-auto mb-8 mx-6 lg:mx-[64px] flex justify-center font-[500] "> <Headings text={'Review'} type={`h3`}/>  </div>
              
          </div>

          <ReviewContent
              selectedShippingType={selectedShippingType}
              cart={cart}
              cartItems={cartItems}
              address={address}
              translations={translations}
              card_types={card_types}
              deliveryMap={deliveryMap}
              chilledDeliveryMap={chilledDeliveryMap}
              shipping_id={shipping_id}
              bundleType={bundleType}
          />
      </div>
       
    </div>
  );
};

ExtendedCartReviewModal.propTypes = {};
